import React from "react";
import './Link.css';

const Link1 = () => {
  return (
    <div className="links">
    <div className="container">
    <div className="column">
    <h3 className="perfect" style={{marginTop : "170px"}}>Bar Closing(Ice Bank Cooler)</h3>
    </div>

    <div className="cardstart" style={{marginTop : "40px"}}>
    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link41a.webp">
          <source src="link41a.mp4" type="video/mp4" />
        </video>      
      </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"><b>Step 1 : </b>Disengage, turn dispenser anti-clockwise and lift it up
        <b style={{fontWeight:'500', fontSize:'1rem' , marginLeft:'5px'}}>Push down the entire lever, squeeze the lower lever so that you can disengage the dispenser </b> </h5>
      </div>
    </div>

     
<div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link42a.webp">
          <source src="link42a.mp4" type="video/mp4" />
        </video>      </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"><b>Step 2 : </b>Connect the dispenser to the flushing adapter and turn it clockwise to secure it. Turn on water supply</h5>
      </div>
    </div>
 
    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link43a.webp">
          <source src="link43a.mp4" type="video/mp4" />
        </video>      </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"><b>Step 3 : </b>Use a tissue to wipe away excess beer from keg spearhead
        <b style={{fontWeight:'500', fontSize:'1rem' , marginLeft:'5px'}}>(IMPORTANT) This is for hygiene purposes to ensure the remaining beer in the keg does not get contaminated</b>
           </h5>
      </div>
    </div>

    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link44a.webp">
          <source src="link44a.mp4" type="video/mp4" />
        </video>      </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"><b>Step 4 : </b>Use another piece of tissue to seal the spearhead
        <b style={{fontWeight:'500', fontSize:'1rem' , marginLeft:'5px'}}>(IMPORTANT) This is for hygiene purposes to ensure the remaining beer in the keg does not get contaminated</b>
       </h5>
      </div>
    </div>

    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link45a.webp">
          <source src="link45a.mp4" type="video/mp4" />
        </video>      </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 5 : </b>Turn on the beer tap by pulling the handle towards you to flush out the remaining beer in the system. Stop when you see clear water flow
          </h5>
      </div>
    </div>

    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link46a.webp">
          <source src="link46a.mp4" type="video/mp4" />
        </video>      </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"><b>Step 6 : </b>Turn off the CO2 supply by turning the cylinder knob clockwise</h5>
      </div>
    </div>

    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link47a.webp">
          <source src="link47a.mp4" type="video/mp4" />
        </video>      </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"><b>Step 7 : </b>On the following day before bar opening, turn on the CO2 supply by turning the cylinder knob anti-clockwise</h5>
      </div>
    </div>
    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link48a.webp">
          <source src="link48a.mp4" type="video/mp4" />
        </video>      </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"><b>Step 8 : </b>Remove the tissue on the spearhead</h5>
      </div>
    </div>

    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link49a.webp">
          <source src="link49a.mp4" type="video/mp4" />
        </video>      </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description">  <b>Step 9 : </b>Turn off the water supply and turn the dispenser anti-clockwise to remove it from the flushing adapter </h5>
      </div>
    </div>

    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link410a.webp">
          <source src="link410a.mp4" type="video/mp4" />
        </video>      </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 10 : </b>Connect the dispenser back to the keg spearhead, 
            turn it clockwise to engage it and squeeze the lever before pressing it down
            <b style={{fontWeight:'500', fontSize:'1rem' , marginLeft:'5px'}}>Align the dispenser with the spearhead first before attempting to engage it</b> 
          </h5>
      </div>
    </div>

    <div className="cardf">
      <div className="cardf-image-container">
      <video width="100%" height="100%" controls poster="link411a.webp">
          <source src="link411a.mp4" type="video/mp4" />
        </video>      </div>
      <div className="cardf-content">
        <h2 className="cardf-title"></h2>
        <h5 className="cardf-description"> <b>Step 11 : </b>Pull the beer tap handle towards you to flush out the water in your system and stop when you see clear beer flow</h5>
      </div>
    </div>

    

</div>
    </div>
    </div>

    )
}

export default Link1;

